var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacing = function SvgFacing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    fillRule: "evenodd",
    d: "M28.765 19.528a10.91 10.91 0 0 0-9.059-9.06L18 12.176l-1.707-1.706a10.91 10.91 0 0 0-9.059 9.059l1.707 1.706-1.707 1.706a10.91 10.91 0 0 0 9.06 9.06L18 30.292l1.706 1.706a10.91 10.91 0 0 0 9.059-9.059l-1.706-1.706zm-15.383 3.34 6.252-6.251 2.84.142.143 2.84-6.251 6.252-2.84-.142z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M18 35.297c7.767 0 14.063-6.296 14.063-14.063 0-7.766-6.297-14.062-14.063-14.062S3.938 13.468 3.938 21.234c0 7.767 6.295 14.063 14.062 14.063M15.363 4.922c-1.16 0-2.11-.95-2.11-2.11s.95-2.109 2.11-2.109h5.274c1.16 0 2.11.95 2.11 2.11s-.95 2.109-2.11 2.109"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M20.11 7.172V3.867h-4.22v3.305"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "m19.634 16.617 2.84.143.143 2.84-6.251 6.252-2.84-.143-.143-2.84z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "m16.758 19.992 2.486 2.486"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgFacing;